import { Core } from "@/core/Core";

export default {
  async reportCateringPrep(context, {options}) {
    try {
      return await Core.request("GET", "/api/reports/catering_prep", options);
    } catch (e) {
      return null;
    }
  },
  
  async reportCateringDeliveries(context, {options}) {
    try {
      return await Core.request("GET", "/api/reports/catering_deliveries", options);
    } catch (e) {
      return null;
    }
  },
  
  async reportLoyaltyTransactions(context, {options}) {
    try {
      return await Core.request("GET", "/api/reports/loyalty_transactions", options);
    } catch (e) {
      return null;
    }
  },
  
  async reportAccountBalances(context, {options}) {
    try {
      return await Core.request("GET", "/api/reports/account_balances", options);
    } catch (e) {
      return null;
    }
  },

  async reportGiftCardTransactions(context, {options}) {
    try {
      return await Core.request("GET", "/api/reports/gift_card_transactions", options);
    } catch (e) {
      return null;
    }
  },

  async reportGiftCardBalances(context, {options}) {
    try {
      return await Core.request("GET", "/api/reports/gift_cards", options);
    } catch (e) {
      return null;
    }
  },
}